import React, { memo } from 'react';
import { bool, number, string } from 'prop-types';
import ProductStatusChangeAlert from '../productStatusChangeAlert/ProductStatusChangeAlert';
import ProductImage from '../../../atoms/productImage';
import './productStatusDetails.scss';
import { PRODUCT_CHANGE_STATUS } from '../constants';

const { UNAVAILABLE } = PRODUCT_CHANGE_STATUS;

const ProductStatusDetails = ({
    productName,
    thumbnailUrl = '',
    unavailableAlertMsg,
    dataTestid = '',
    showImage = true,
    status = UNAVAILABLE,
    maxAvailableQty = 0
}) => {
    return (
        <div className="product-status-details__wrapper" data-testid={dataTestid}>
            {showImage && (
                <ProductImage
                    url={thumbnailUrl}
                    defaultViewCardType="minicart"
                    name={productName}
                    className="product-status-details__image"
                />
            )}
            <div className="product-status-details">
                {productName}
                <ProductStatusChangeAlert status={status} alertMsg={unavailableAlertMsg} maxAvailableQty={maxAvailableQty} />
            </div>
        </div>
    );
};

ProductStatusDetails.propTypes = {
    productName: string,
    thumbnailUrl: string,
    unavailableAlertMsg: string,
    dataTestid: string,
    showImage: bool,
    status: string,
    maxAvailableQty: number
};

export default memo(ProductStatusDetails);
